export const types = Object.freeze({
    /* Get Calls */
    DASHBOARD_TABLE_CALLS_ASYNC: 'DASHBOARD_TABLE_CALLS_ASYNC',
    DASHBOARD_TABLE_CALLS: 'DASHBOARD_TABLE_CALLS',
    DASHBOARD_TABLE_CALLS_ERROR: 'DASHBOARD_TABLE_CALLS_ERROR',
    DASHBOARD_TABLE_CALLS_START_FETCHING: 'DASHBOARD_TABLE_CALLS_START_FETCHING',
    DASHBOARD_SET_TABLE_CALLS_LIST_PARAMS: 'DASHBOARD_SET_TABLE_CALLS_LIST_PARAMS',
});
